<div class="wrapper--date-form">
  <input
    nxDatefield
    type="text"
    class="date-form--hidden"
    [datepicker]="datepicker"
    [min]="field.datePicker?.minDate ?? null"
    [max]="field.datePicker?.maxDate ?? null"
    [datefieldFilter]="field.datePicker?.filter ?? defFilter"
    [(ngModel)]="datepickerDate"
    (ngModelChange)="onDateChange($event)"
  />

  <nx-formfield [formGroup]="formGroup" nxFloatLabel="auto" [label]="field.title ?? '' | translate">
    <nx-formfield-label>
      {{ field.label | translate }}
      <span *ngIf="field.required">*</span>
    </nx-formfield-label>

    <input
      dateValidator
      nxInput
      type="text"
      [formControlName]="field.name"
      [customMask]="field.mask!"
      [azDateFormatter]="field.format || ''"
      [attr.autocomplete]="(field.options?.removeSuggestions && 'off') ?? null"
    />
    <span nxFormfieldHint *ngIf="field.hint">{{ field.hint | translate }}</span>
    <span class="wrapper--date-form--autocomplete" *ngIf="field.mask">
      <span class="transparent">
        {{ formGroup.controls[field.name].value }}
      </span>
      <!-- {{
        field.maskText || field.mask
          | slice: formGroup.controls[field.name].value?.length || 0
      }} -->
    </span>

    <nx-datepicker-toggle [for]="datepicker" nxFormfieldSuffix></nx-datepicker-toggle>
    <nx-datepicker
      #datepicker
      [startView]="newDate ? 'month' : field.datePicker?.startView || 'month'"
      [startAt]="field.datePicker?.startDate || null"
      [panelClass]="field.datePicker?.panelClass || ''"
      (closed)="onDatepickerClosed()"
    ></nx-datepicker>

    <nx-error
      nxFormfieldError
      *ngFor="
        let item of (!field.hideErrorBox && formGroup.controls[field.name]?.errors) || {}
          | arrayKeys
      "
    >
      {{
        (field.customErrorLabel && field.customErrorLabel[item]
          ? field.customErrorLabel[item]
          : 'azForm.errors.' + item
        ) | translate
      }}
    </nx-error>
  </nx-formfield>
</div>
